var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranspanvySend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M3.1 9.49981C3.1 4.99981 6.7 1.3998 11.2 1.2998C11.2 1.2998 11.2 1.2998 11.3 1.2998C15.8 1.2998 19.4 5.0998 19.4 9.5998V10.3998C19.4 14.4998 20.2 16.7998 21 18.0998C21.3 18.4998 21.1 19.0998 20.7 19.2998C20.6 19.3998 20.4 19.3998 20.3 19.3998H2.4C1.9 19.3998 1.5 18.9998 1.5 18.4998C1.5 18.2998 1.5 18.1998 1.6 18.0998C2.3 16.7998 3.2 14.4998 3.2 10.3998V9.49981H3.1Z",
    fill: "#7FBB51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59961 23.0996H14.8996",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 9.49981C3.1 4.99981 6.7 1.3998 11.2 1.2998C11.2 1.2998 11.2 1.2998 11.3 1.2998C15.8 1.2998 19.4 5.0998 19.4 9.5998V10.3998C19.4 14.4998 20.2 16.7998 21 18.0998C21.3 18.4998 21.1 19.0998 20.7 19.2998C20.6 19.3998 20.4 19.3998 20.3 19.3998H2.4C1.9 19.3998 1.5 18.9998 1.5 18.4998C1.5 18.2998 1.5 18.1998 1.6 18.0998C2.3 16.7998 3.2 14.4998 3.2 10.3998V9.49981H3.1Z",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranspanvySend);
export default __webpack_public_path__ + "static/media/transpanvy-send.84276ec574f2d1d8593cf29a70e4579d.svg";
export { ForwardRef as ReactComponent };